(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('MarketPriceDialogController', MarketPriceDialogController);

    MarketPriceDialogController.$inject = ['$scope', '$timeout', '$stateParams', '$uibModalInstance', 'entity', 'MarketPrice', 'MarketPriceCustomService', 'ToastrService'];

    function MarketPriceDialogController($scope, $timeout, $stateParams, $uibModalInstance, entity, MarketPrice, MarketPriceCustomService, ToastrService) {
        var vm = this;

        vm.marketPrice = entity;
        vm.priceTypes = ['CTS'];
        vm.wtUnitTypes = ['LB'];
        vm.months = ['MAR','MAY','JUL','OCT','DEC'];

        vm.clear = clear;
        vm.save = save;
        vm.updatePriceDisplay = updatePriceDisplay;
        vm.onTextClick = onTextClick;

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if(vm.marketPrice.id !== null) {
                MarketPrice.update(vm.marketPrice, onSaveSuccess, onSaveError);
            } else {
                MarketPrice.save(vm.marketPrice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('ccsTrApp:marketPriceUpdate', result);
            ToastrService.success("Successfully saved Market Price", "Success!");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error");
            vm.isSaving = false;
        }

        function updatePriceDisplay() {
            vm.marketPrice.priceDisplay = vm.marketPrice.price + " " + vm.marketPrice.priceType + "/" + vm.marketPrice.wtUnitType;
        }

        function onTextClick($event) {
            $event.target.select();
        }
    }
})();
